import {ICON_TYPES} from '../constants';
import {IconPropsType} from '../IconProps.type';

export const CommunityPhase = (props: IconPropsType): JSX.Element => {
  const svgProps = {
    fill: props.fill || '#43494F',
    width: props.width || '21',
    height: props.height || '21',
  };
  return (
    <svg
      {...svgProps}
      viewBox='0 0 21 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_3409_212235)'>
        <path
          d='M11.375 1.75V7.875H1.75V2.625C1.75 2.39294 1.84219 2.17038 2.00628 2.00628C2.17038 1.84219 2.39294 1.75 2.625 1.75H11.375ZM13.125 0H2.625C1.92881 0 1.26113 0.276562 0.768845 0.768845C0.276562 1.26113 0 1.92881 0 2.625L0 9.625H13.125V0Z'
          fill={svgProps.fill}
        />
        <path
          d='M18.375 1.75C18.6071 1.75 18.8296 1.84219 18.9937 2.00628C19.1578 2.17038 19.25 2.39294 19.25 2.625V7.875H16.625V1.75H18.375ZM18.375 0H14.875V9.625H21V2.625C21 1.92881 20.7234 1.26113 20.2312 0.768845C19.7389 0.276562 19.0712 0 18.375 0Z'
          fill={svgProps.fill}
        />
        <path
          d='M4.375 13.125V19.25H2.625C2.39294 19.25 2.17038 19.1578 2.00628 18.9937C1.84219 18.8296 1.75 18.6071 1.75 18.375V13.125H4.375ZM6.125 11.375H0V18.375C0 19.0712 0.276562 19.7389 0.768845 20.2312C1.26113 20.7234 1.92881 21 2.625 21H6.125V11.375Z'
          fill={svgProps.fill}
        />
        <path
          d='M19.25 13.125V18.375C19.25 18.6071 19.1578 18.8296 18.9937 18.9937C18.8296 19.1578 18.6071 19.25 18.375 19.25H9.625V13.125H19.25ZM21 11.375H7.875V21H18.375C19.0712 21 19.7389 20.7234 20.2312 20.2312C20.7234 19.7389 21 19.0712 21 18.375V11.375Z'
          fill={svgProps.fill}
        />
      </g>
      <defs>
        <clipPath id='clip0_3409_212235'>
          <rect width={svgProps.width} height={svgProps.height} fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
CommunityPhase.iconType = ICON_TYPES.COMMUNITY_PHASE_ICON;
